import { fetchWithAuth } from '../lib/fetchWithAuth';

const API_BASE_URL = import.meta.env.VITE_API_URL?.replace(/\/$/, '');

export type EmployerBrandingPayload = {
  companyName: string;
  tagline?: string;
  description?: string;
  logoUrl?: string;
  logoUploadId?: string;
  coverUrl?: string;
  coverUploadId?: string;
  galleryUrls?: string[];
  galleryUploadIds?: string[];
  benefits?: string[];
};

export async function fetchEmployerBranding(): Promise<EmployerBrandingPayload | undefined> {
  if (!API_BASE_URL) return undefined;
  const response = await fetchWithAuth(`${API_BASE_URL}/v1/employer/branding`, { method: 'GET' });
  if (response.status === 404) return undefined;
  if (!response.ok) {
    const text = await response.text().catch(() => 'request failed');
    throw new Error(`Branding fetch failed (${response.status}): ${text}`);
  }
  return (await response.json()) as EmployerBrandingPayload;
}

export async function saveEmployerBranding(payload: EmployerBrandingPayload): Promise<boolean> {
  if (!API_BASE_URL) {
    throw new Error('Branding save requires VITE_API_URL to be configured.');
  }
  const response = await fetchWithAuth(`${API_BASE_URL}/v1/employer/branding`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  if (!response.ok) {
    const text = await response.text().catch(() => 'request failed');
    throw new Error(`Branding save failed (${response.status}): ${text}`);
  }
  return true;
}
